// extracted by mini-css-extract-plugin
module.exports = {"phoneArea":"style_phoneArea__t1QHS","phoneNumber":"style_phoneNumber__BIDcF"};